import { render, staticRenderFns } from "./CardCategory.vue?vue&type=template&id=568a3c48&scoped=true"
import script from "./CardCategory.vue?vue&type=script&lang=js"
export * from "./CardCategory.vue?vue&type=script&lang=js"
import style0 from "./CardCategory.vue?vue&type=style&index=0&id=568a3c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568a3c48",
  null
  
)

export default component.exports